export const NAME = 'persons'

// API routes
export const POST_PERSON_GRAPH_ROUTE = 'personGraphPost'

// Waiter names
export const GET_FAMILY_REQUEST = 'persons:getFamily()'
